import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { DATE_FORMAT } from 'src/pages/Settings/users/const';
import { useDisplayTime } from 'src/utils/hooks';

export const DateCell = ({
  date,
  dateFormat = DATE_FORMAT,
  includeTime = false,
}: {
  date?: string;
  dateFormat?: string;
  includeTime?: boolean;
}) => {
  const { timeFormat } = useDisplayTime();

  const format = includeTime ? `${dateFormat}, ${timeFormat}` : dateFormat;

  return (
    <Box>
      <Typography
        variant="body1"
        fontSize="small"
        sx={{ whiteSpace: 'nowrap' }}
        component="span"
      >
        {date ? dayjs(date).format(format) : '-'}
      </Typography>
    </Box>
  );
};
